<template>
  <wo-data-table :mod-hover="modSelectable">
    <table class="po-table" :class="classes">
      <thead class="po-table__header">
        <slot name="header"></slot>
      </thead>
      <tbody class="po-table__body">
        <slot name="body"></slot>
      </tbody>
    </table>
  </wo-data-table>
</template>
<script>

export default {
  name: 'PoTable',
  props: {
    modNoVBorders: Boolean,
    modNoHBorders: Boolean,
    modSelectable: Boolean
  },
  computed: {
    classes () {
      return {
        'po-table--no-v-borders': this.modNoVBorders,
        'po-table--no-h-borders': this.modNoHBorders,
        'po-table--selectable': this.modSelectable
      }
    }
  }
}
</script>

<style lang="scss">

$po-table-cell-icon-size: 1.5em;
$po-table-cell-media-size: 7em;

.wo-data-table {
  .po-table {

    &--no-v-borders {
      .po-table__body td, .po-table__header th {
        border-right-color: transparent;
      }
    }

    &--no-h-borders {
      border-top-color: transparent;

      .po-table__body td, .po-table__header th {
        border-bottom-color: transparent;
      }
    }

    td {
      vertical-align: middle;

      &.po-table__cell--icon {
        padding-right: 0;
        width: $po-table-cell-icon-size;

        .wo-icon {
          height: $po-table-cell-icon-size;
          width: $po-table-cell-icon-size;
          .wo-icon__svg-icon {
           height: $po-table-cell-icon-size;
           width: $po-table-cell-icon-size;
          }
        }

         &.po-table__cell--image {
          padding-right: 0;

          img {
            width: auto;
          }
         }
      }

      &.po-table__cell--media {
        padding-right: 0;
        width: $po-table-cell-media-size;
      }
    }
  }
}
</style>
